<template>
  <div class="g-module flex-column" :class="{'flex-grow-auto': !height}">
    <div v-if="title || tabList" class="g-module-head flex-between-center">
      <div v-if="tabList" class="tab flex">
        <div v-for="(item, i) in tabList" :key="i" class="tab-item" :class="{'z-crt': currentTab == item}"
             @click="tabHandle(item)">
          {{ item.title }}
        </div>
      </div>
      <div v-else class="title flex-baseline">
        <p>{{ title }}</p>
        <span v-if="subTitle">{{ subTitle }}</span>
      </div>
    </div>
    <div class="g-module-content"
         :class="{'flex-column': flexColumn, 'flex': flexRow, 'flex-grow-auto': !columnScroll, 'flex-grow': columnScroll}"
         :style="{'height': parsePixel(height)}">
      <slot></slot>
    </div>
    <div v-if="$slots.button" class="g-module-button flex-center">
      <slot name="button"></slot>
    </div>
    <c-dialog ref="editExportColumnDialog" :title="columnDialogTitle" width="1200" height="600"
              @resolve="submitExportColumnHandle">
      <m-operate>
        <c-button color="sys" icon="add" @click="addRow()">添加字段</c-button>
      </m-operate>
      <c-table ref="field" :paging="false" v-model="fieldList" height="560">
        <c-table-column label="字段名称" name="field_title" width="130">
          <template v-slot="{data}">
            <c-input v-model="data.field_title" type="input" maxlength="30"></c-input>
          </template>
        </c-table-column>

        <c-table-column label="字段代码【表内唯一】" name="field_code" width="160">
          <template v-slot="{data}">
            <c-input v-model="data.field_code" type="input" maxlength="30"></c-input>
          </template>
        </c-table-column>


        <c-table-column type="sort" label="排序" @sort="categorySort"></c-table-column>

        <c-table-column label="字段类型" name="field_title" width="120">
          <template v-slot="{data}">
            <c-select v-model="data.field_type" :options="fieldTypeOptions"></c-select>
          </template>
        </c-table-column>

        <c-table-column label="导出配置" name="config_json" width="310">
          <template v-slot="{data}">
            <textarea v-model="data.config_json" cols="40" rows="4"></textarea>
          </template>
        </c-table-column>

        <c-table-column label="列宽" name="width" width="70">
          <template v-slot="{data}">
            <c-input v-model="data.width" type="number" :limit="[50,500]"></c-input>
          </template>
        </c-table-column>
        <c-table-column label="是否展示" name="is_display" width="70">
          <template v-slot="{data}">
            <span v-if="data.is_display==0" style="color:red">隐藏</span>
            <span v-if="data.is_display==1" style="color:green">显示</span>
          </template>
        </c-table-column>

        <c-table-column type="button" label="操作" width="110" align-center :title="false">
          <template v-slot="row">
            <c-table-button @click="displayHandle(row)" v-if="row.data.is_display==0">显示</c-table-button>
            <c-table-button @click="displayHandle(row)" v-if="row.data.is_display==1">隐藏</c-table-button>
            <c-table-button @click="row.remove()">删除</c-table-button>
          </template>
        </c-table-column>
      </c-table>
    </c-dialog>
  </div>
</template>

<script>
export default {
  name: 'module',

  props: {
    height: [Number, String],

    enableFlex: Boolean,

    title: String,

    subTitle: String
  },

  data() {
    return {
      complexWarpper: false,
      columnScroll: false,
      tabList: '',
      currentTab: '',
      columnDialogTitle: '编辑导出数据列字段',
      fieldTypeOptions: [
        {name: '普通文本', value: 0},
        {name: '数量(取整)', value: 1},
        {name: '数字(两位小数)', value: 2},
        {name: '金额(千分位)', value: 3},
        {name: '日期(时分秒)', value: 4},
        {name: '百分比(%)', value: 5}
      ],
      workType: 0,         //业务类型
      fieldList: []        //导出字段
    }
  },

  computed: {
    compEnableFlex() {
      return this.enableFlex || this.complexWarpper;
    },

    flexColumn() {
      return this.compEnableFlex && !this.complexWarpper;
    },

    flexRow() {
      return this.compEnableFlex && this.complexWarpper;
    }
  },

  watch: {
    currentTab(val) {
      val.activated()
    }
  },

  methods: {
    resize() {
      this.$children.forEach(item => {
        if (['moduleTab', 'moduleArea', 'charts'].includes(item.$options.name)) {
          item.resize && item.activatedState !== false && item.resize();
        }
      });
      this.$emit('resize');
    },

    insertTab(tab) {
      if (!this.currentTab) {
        this.currentTab = tab;
      }
      if (!this.tabList) {
        this.tabList = [];
      }
      this.tabList.push(tab);
    },

    tabHandle(tab) {
      if (tab == this.currentTab) return;
      let stop = false;
      if (this.currentTab) {
        this.currentTab.deactivated(false, () => {
          stop = true;
        });
      }

      if (!stop) {
        this.currentTab.deactivated(true);
        this.currentTab = tab;
      }
    },
    /**
     * 编辑导出数据列
     * @param workType 业务类型
     */
    editExportColumn(workType) {
      this.workType = workType;
      //加载字段列表
      this.request({
        url: '/export/field/list',
        data: {
          work_type: this.workType
        },
        success: resultData => {
          this.columnDialogTitle = '编辑【' + resultData.work_type_name + '】列表导出数据字段';
          this.fieldList = resultData.field_list;
          this.$refs.editExportColumnDialog.open();
        }
      });
    },
    /**
     * 字段显示隐藏
     * @param row
     */
    displayHandle(row) {
      row.data.is_display = row.data.is_display == 1 ? 0 : 1;
    },
    //排序
    categorySort(row, type, next) {
      next();
    },
    //添加字段
    addRow(row, type, next) {
      var newRow = {};
      newRow.field_code = '';
      newRow.field_title = '';
      newRow.field_type = 0;
      newRow.width = '100';
      newRow.is_display = 1;
      newRow.config_json = '';
      this.fieldList.push(newRow);
    },
    /**
     * 提交导出数据列
     * @param productWorkType 业务类型
     */
    submitExportColumnHandle(stop) {
      stop();
      var submitFlag = true;
      if (!this.fieldList || this.fieldList.length == 0) {
        this.$message({
          text: '请至少保留一个导出字段！',
          icon: 'fail'  // 图标（success：成功，fail：失败）
        });
        submitFlag = false;
        return;
      }
      this.fieldList.forEach(item => {
        if (!item.field_code) {
          this.$message({
            text: '请输入字段代码',
            icon: 'fail'  // 图标（success：成功，fail：失败）
          });
          submitFlag = false;
          return;
        }
        if (!item.field_title) {
          this.$message({
            text: '请输入字段名称',
            icon: 'fail'  // 图标（success：成功，fail：失败）
          });
          submitFlag = false;
          return;
        }
      });
      if (submitFlag) {
        this.request({
          url: '/export/field/edit',
          data: {
            work_type: this.workType,
            field_list: this.fieldList
          },
          success: data => {
            this.$message({
              text: '编辑成功！',
              icon: 'success'  // 图标（success：成功，fail：失败）
            });
            this.$refs.editExportColumnDialog.close();
          }
        });
      }
    },
    /**
       * 查询往前推N天的时间
       * @param num         前推天数
       * @param time        开始时间
       * @returns {string}
   */
    getBeforeDate(num, time) {
          let n = num;
          let d = '';
          if(time) {
              d = new Date(time);
          } else {
              d = new Date();
          }
          let year = d.getFullYear();
          let mon = d.getMonth() + 1;
          let day = d.getDate();
          if(day <= n) {
              if(mon > 1) {
                  mon = mon - 1;
              } else {
                  year = year - 1;
                  mon = 12;
              }
          }
          d.setDate(d.getDate() - n);
          year = d.getFullYear();
          mon = d.getMonth() + 1;
          day = d.getDate();
          let s = year + "-" + (mon < 10 ? ('0' + mon) : mon) + "-" + (day < 10 ? ('0' + day) : day);
          return s;
      }
  }
};
</script>

<style lang="stylus" scoped>
.g-module {
  position: relative;
  background: #fff;

  &:nth-child(n+2) {
    margin-top: 10px;
  }

  &-head {
    z-index: 99;
    position: sticky;
    top: 0;
    min-height: 46px;
    border-bottom: 1px solid #ddd;
    background: #fff;

    .title {
      padding-left: 22px;

      p {
        font-size: 16px;
        font-weight: bold;
      }

      span {
        margin-left: 10px;
        font-size: 14px;
      }
    }

    .tab {
      &-item {
        position: relative;
        padding: 0 25px;
        line-height: 46px;
        font-size: 16px;
        color: #666;
        cursor: pointer;

        &:hover,
        &.z-crt {
          font-weight: bold;
          color: #000;
        }

        &:after {
          content: '';
          position: absolute;
          left: 50%;
          bottom: 0;
          width: 0;
          height: 2px;
        theme-background(main);
          transform: translate(-50%, 0);
          transition: width .3s ease;
        }

        &.z-crt:after {
          width: 30px;
        }
      }
    }
  }

  &-content {
    position: relative;
  }

  >>> &-tab {
    background: #fff;

    &:not(.z-active) {
      display: none;
      position: absolute;
      width: 100%;
      height: 0;
      overflow: hidden;
    }

    &.z-active {
      position: static;
    }
  }

  >>> &-column {
    &:nth-child(n+2) {
      border-left: 1px solid #ddd;
      margin-left: 2px;
    }

    &:nth-last-child(n+2) {
      border-right: 1px solid #ddd;
      margin-right: 2px;
    }
  }

  >>> &-button {
    z-index: 99;
    position: sticky;
    bottom: 0;
    min-height: 60px;
    border-top: 1px solid #E0E2EA;
    background: #fff;

    .c-button {
      margin: 0 8px;
    }
  }
}
</style>
